import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { logout } from "./common/helpers/auth";

export class MasterTopbar extends Component {
  static defaultProps = {
    onMenuButtonClick: null,
    onTopbarMenuButtonClick: null,
    onTopbarItemClick: null,
    profileMode: null,
    horizontal: false,
    topbarMenuActive: false,
    activeTopbarItem: null,
    onRightPanelButtonClick: null
  };

  static propTypes = {
    onMenuButtonClick: PropTypes.func.isRequired,
    onTopbarMenuButtonClick: PropTypes.func.isRequired,
    onTopbarItemClick: PropTypes.func.isRequired,
    profileMode: PropTypes.string.isRequired,
    horizontal: PropTypes.bool.isRequired,
    topbarMenuActive: PropTypes.bool.isRequired,
    activeTopbarItem: PropTypes.string,
    onRightPanelButtonClick: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = {};
  }

  onTopbarItemClick(event, item) {
    if (this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item
      });
    }
  }

  render() {
    let topbarItemsClassName = classNames("topbar-items animated fadeInDown", {
      "topbar-items-visible": this.props.topbarMenuActive
    });

    return (
      <div className="topbar clearfix">
        <div className="topbar-left">
          <img
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "90%",
              height: "100%"
            }}
            src="/assets/layout/images/bpp/bpp-logo-text.png"
            alt="Belfast Pilates & Physiotherapy - Specialising in Physio led Pilates"
          />
        </div>

        <div className="topbar-right">
          <a id="menu-button" onClick={this.props.onMenuButtonClick}>
            <i />
          </a>

          <a
            id="topbar-menu-button"
            onClick={this.props.onTopbarMenuButtonClick}
          >
            <i className="material-icons">menu</i>
          </a>
          <ul className={topbarItemsClassName}>
            {(this.props.profileMode === "top" || this.props.horizontal) && (
              <li
                className={classNames("profile-item", {
                  "active-top-menu": this.props.activeTopbarItem === "profile"
                })}
              >
                <a onClick={e => this.onTopbarItemClick(e, "profile")}>
                  <img
                    className="profile-image"
                    src="assets/layout/images/avatar.png"
                    alt="Profile"
                  />
                  <span className="topbar-item-name">
                    {localStorage.getItem("email")}
                  </span>
                </a>

                <ul className="ultima-menu animated fadeInDown">
                  <li
                    role="menuitem"
                    onClick={() => {
                      logout();
                      localStorage.clear();
                      window.location = "#/";
                      window.location.reload();
                    }}
                  >
                    <a>
                      <i className="material-icons">power_settings_new</i>
                      <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </li>
            )}

            <li
              className={classNames({
                "active-top-menu": this.props.activeTopbarItem === "settings"
              })}
            >
              <a onClick={e => this.onTopbarItemClick(e, "settings")}>
                <i className="topbar-icon material-icons">settings</i>
                <span className="topbar-item-name">Settings</span>
              </a>
              <ul className="ultima-menu animated fadeInDown">
                <li
                  role="menuitem"
                  onClick={() => {
                    window.location = "#/employees";
                  }}
                >
                  <a>
                    <i className="material-icons">person</i>
                    <span>Employees</span>
                  </a>
                </li>
                {localStorage.getItem("roleType") !== "10" ? (
                  <li />
                ) : (
                  <li
                    role="menuitem"
                    onClick={() => {
                      window.location = "#/businesssettings";
                    }}
                  >
                    <a>
                      <i className="material-icons">settings</i>
                      <span>Business Settings</span>
                    </a>
                  </li>
                )}
                <li
                  role="menuitem"
                  onClick={() => {
                    logout();
                    localStorage.clear();
                    window.location = "#/";
                    window.location.reload();
                  }}
                >
                  <a>
                    <i className="material-icons">power_settings_new</i>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MasterTopbar.js